/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
 */
export interface PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit {
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  name?: string | null;
  /**
   *
   * @type {CredentialRead}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  serverUrl: string;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  apiKey: string;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  agentName: string;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  dispatchMetadata?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  maxDuration?: number;
  /**
   *
   * @type {number}
   * @memberof PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit
   */
  maxConcurrency?: number;
}

/**
 * Check if a given object implements the PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit interface.
 */
export function instanceOfPatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit(
  value: object,
): value is PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('serverUrl' in value) || value['serverUrl'] === undefined) return false;
  if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
  if (!('agentName' in value) || value['agentName'] === undefined) return false;
  return true;
}

export function PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSON(
  json: any,
): PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit {
  return PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSONTyped(json, false);
}

export function PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit {
  if (json == null) {
    return json;
  }
  return {
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    serverUrl: json['server_url'],
    apiKey: json['api_key'],
    agentName: json['agent_name'],
    dispatchMetadata: json['dispatch_metadata'] == null ? undefined : json['dispatch_metadata'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
    maxConcurrency: json['max_concurrency'] == null ? undefined : json['max_concurrency'],
  };
}

export function PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitToJSON(
  value?: Omit<PatchedVoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    server_url: value['serverUrl'],
    api_key: value['apiKey'],
    agent_name: value['agentName'],
    dispatch_metadata: value['dispatchMetadata'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
    max_concurrency: value['maxConcurrency'],
  };
}
